import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';
import Colors from '../../../../shared/assets/style/default/color';
import { TRANSITION } from '../../../../shared/types/constants/animations';

const DiskCapacityInnerBar = styled.div<{ width: number }>`
  width: ${(props) => props.width * 100}%;
  height: ${90 * Screen.widthRatio}px;
  background: ${Colors.progress.fill};
  transition: ${TRANSITION.DISK_CAPACITY_INNER_BAR};
`;

export default DiskCapacityInnerBar;
